import { render, staticRenderFns } from "./CardPage.vue?vue&type=template&id=4007b215&scoped=true&"
import script from "./CardPage.vue?vue&type=script&lang=ts&"
export * from "./CardPage.vue?vue&type=script&lang=ts&"
import style0 from "./CardPage.vue?vue&type=style&index=0&id=4007b215&lang=stylus&scoped=true&"
import style1 from "./CardPage.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4007b215",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
